import { Fragment } from 'react';

import { ARPU } from './ARPU';
import { AudiencePopover } from './AudiencePopover';
import { AudienceSize } from './AudienceSize';
import { EmailTemplate } from './EmailTemplate';
import { LTV } from './LTV';
import { MetaSwitch } from './MetaSwitch';
import { OmnichatSwitch } from './OmnichatSwitch';
import { ProductsInSet } from './ProductsInSet';
import { PublicLink } from './PublicLink';
import { SimilarityScore } from './SimilarityScore';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { useAuth } from '@/contexts/AuthContext';
import { Audience } from '@/services/AudiencesService';

interface AudienceCardProps {
  audience: Audience;
}

export function AudienceCard({ audience }: AudienceCardProps) {
  const { user } = useAuth();

  const integrationSwitchs = [
    {
      id: 1,
      active: !!user?.customer.meta_user_token,
      component: <MetaSwitch audience={audience} />,
    },
    {
      id: 2,
      active:
        !!user?.customer.omnichatApiKey && !!user?.customer.omnichatApiSecret,
      component: <OmnichatSwitch audience={audience} />,
    },
  ];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-lg font-bold">{audience.name}</CardTitle>
        <AudiencePopover audience={audience} />
      </CardHeader>

      <CardContent>
        <div className="flex flex-col gap-2">
          <AudienceSize audience={audience} />

          <ProductsInSet audience={audience} />

          <EmailTemplate audience={audience} />

          <SimilarityScore audience={audience} />

          <LTV audience={audience} />

          <ARPU audience={audience} />
        </div>

        <PublicLink audience={audience} />

        {integrationSwitchs.some((sw) => sw.active) && (
          <div className="my-2 border-t border-gray-200" />
        )}

        {integrationSwitchs.map(({ active, component, id }) => {
          if (!active) {
            return null;
          }

          return <Fragment key={id}>{component}</Fragment>;
        })}
      </CardContent>
    </Card>
  );
}
